import React, { useContext } from 'react';

import { useRecoilValue } from 'recoil';
import { useIntl } from 'react-intl';
import AppContext from '../state/AppContext';
import ScreenWelcome from './ScreenWelcome';
import ScreenSubservices from './ScreenSubservices';
import ScreenMap from './ScreenMap';
import ScreenSignup from './ScreenSignup';
import ScreenConfirmation from './ScreenConfirmation';
import {
  selectedServiceIdState,
  selectedSubserviceIdState,
  selectedTimeSlotState,
} from '../state/selected';

const ScreenSwitcher = () => {
  const intl = useIntl();
  const {
    customerNeedsSignup,
    isAppointmentConfirmed,
  } = useContext(AppContext);

  const selectedTimeSlot = useRecoilValue(selectedTimeSlotState);
  const selectedSubserviceId = useRecoilValue(selectedSubserviceIdState);
  const selectedServiceId = useRecoilValue(selectedServiceIdState);

  if (!selectedServiceId) {
    return <ScreenWelcome />;
  }

  if (!selectedSubserviceId) {
    if (window && window.gtag) {
      window.gtag('event', 'screen_view', {
        screen_name: 'Reason for visit',
        screen_locale: intl.locale,
      });
    }
    return <ScreenSubservices />;
  }

  if (selectedTimeSlot && customerNeedsSignup) {
    if (window && window.gtag) {
      window.gtag('event', 'screen_view', {
        screen_name: 'Finalization / Complete sign-up',
        screen_locale: intl.locale,
      });
    }
    return (
      <ScreenSignup />
    );
  }

  if (isAppointmentConfirmed) {
    if (window && window.gtag) {
      window.gtag('event', 'screen_view', {
        screen_name: 'Confirmation',
        screen_locale: intl.locale,
      });
    }
    return (
      <ScreenConfirmation />
    );
  }

  if (window && window.gtag) {
    window.gtag('event', 'screen_view', {
      screen_name: 'Your availabilities',
      screen_locale: intl.locale,
    });
  }
  return (
    <ScreenMap />
  );
};

ScreenSwitcher.propTypes = {};

export default ScreenSwitcher;
